import type { IncomingMessage } from 'http'
import Common from './common'
import Login from './Login'
import GetHighRiskBankCard from './HighRiskBankCard'
import GetHighRiskIdentityCards from './HighRiskIdentityCards'
import GetSupplyTrend from './SupplyTrend'
import GetBankCardActivityField from './BankCardActivityField'
import GetArticlePublished from './ArticlePublished'
import GetBankCardIQC from './BankCardIQC'
import IntelligenceLeads from './IntelligenceLeads'
import BankcardVag from './BankcardVag'
import UserLog from './UserLog'
import GetTradeBackInfo from './TradeBackInfo'
import GetBuzzwordField from './HotWord'
import MailInfoConfig from '@/apis/MailInfoConfig'
import GetMenu from './Menu'
import Trial from './Trial'
import GetOriginalMessage from './OriginalMessage'
import GetBankPriceTrend from './BankPriceTrend'
import GetGroupContribution from './GroupContribution'
import BankApi from './Bank'
import VersionRelease from './VersionReleaseConfig'

export type TReq = IncomingMessage & {
  cookies: Partial<Record<string, string>>
}

export default {
  Common: new Common(),
  Login: new Login(),
  GetHighRiskBankCard: new GetHighRiskBankCard(),
  GetHighRiskIdentityCards: new GetHighRiskIdentityCards(),
  GetSupplyTrend: new GetSupplyTrend(),
  GetBankCardActivityField: new GetBankCardActivityField(),
  GetArticlePublished: new GetArticlePublished(),
  GetBankCardIQC: new GetBankCardIQC(),
  IntelligenceLeads: new IntelligenceLeads(),
  BankcardVag: new BankcardVag(),
  UserLog: new UserLog(),
  GetTradeBackInfo: new GetTradeBackInfo(),
  GetBuzzwordField: new GetBuzzwordField(),
  MailInfoConfig: new MailInfoConfig(),
  GetMenu: new GetMenu(),
  Trial: new Trial(),
  GetOriginalMessage: new GetOriginalMessage(),
  // 价格趋势 todo: 接口按模块整合
  GetBankPriceTrend: new GetBankPriceTrend(),
  // 群组贡献 todo: 接口按模块整合
  GetGroupContribution: new GetGroupContribution(),
  // 银行相关接口
  BankApi: new BankApi(),
  VersionRelease: new VersionRelease()
}
